import { NavLink } from "react-router-dom";
import { Gauge, Tray, Buildings, UsersThree, SignOut, GearSix, AddressBook, Megaphone, Broadcast, ChartBar, UserPlus, ShieldCheck, EnvelopeSimple, ChartPieSlice } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

const items = [
  { to: "/admin", label: "Dashboard", icon: Gauge, testid: "nav-dashboard" },
  { to: "/ops", label: "Ops Console", icon: Broadcast, testid: "nav-ops" },
  { to: "/incidents", label: "Incidents", icon: Tray, testid: "nav-incidents" },
  { to: "/clients", label: "API Clients", icon: Buildings, testid: "nav-clients" },
  { to: "/client-signups", label: "Sign-ups", icon: UserPlus, testid: "nav-client-signups" },
  { to: "/contacts", label: "Subscribers", icon: AddressBook, testid: "nav-contacts" },
  { to: "/subscriptions", label: "Subscriptions", icon: ShieldCheck, testid: "nav-subscriptions" },
  { to: "/communications", label: "Communications", icon: Megaphone, testid: "nav-communications" },
  { to: "/reports", label: "Reports", icon: ChartBar, testid: "nav-reports" },
  { to: "/comms-hub", label: "Comms Hub", icon: ChartPieSlice, testid: "nav-comms-hub" },
  { to: "/mail-history", label: "Mail History", icon: EnvelopeSimple, testid: "nav-mail-history" },
  { to: "/crew", label: "Responder Crew", icon: UsersThree, testid: "nav-crew" },
  { to: "/settings", label: "Settings", icon: GearSix, testid: "nav-settings" },
];

const ResQShield = ({ size = 26 }) => (
  <svg width={size} height={size * 1.18} viewBox="0 0 60 71" xmlns="http://www.w3.org/2000/svg" aria-label="ResQ1">
    <defs>
      <clipPath id={`sb-clip-${size}`}>
        <path d="M4 6 Q4 1 9 1 L51 1 Q56 1 56 6 L56 38 Q56 55 30 70 Q4 55 4 38 Z" />
      </clipPath>
    </defs>
    <g clipPath={`url(#sb-clip-${size})`}>
      <rect width="60" height="71" fill="#E01A2E" />
      <path d="M-4 44 L30 20 L37 28 L3 56 Z" fill="#F7F5F0" />
    </g>
  </svg>
);

const NAVY = "#0B1E3B";
const WHITE = "#ffffff";
const W65 = "rgba(255,255,255,0.68)";
const W45 = "rgba(255,255,255,0.48)";
const W30 = "rgba(255,255,255,0.30)";
const MONO = "'JetBrains Mono', ui-monospace, monospace";

export default function Sidebar() {
  const { user, logout } = useAuth();
  return (
    <aside
      className="sidebar-chrome w-60 shrink-0 flex flex-col"
      style={{ background: NAVY, color: WHITE, fontFamily: "'Inter', system-ui, sans-serif" }}
      data-testid="sidebar"
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "22px 20px", borderBottom: "1px solid rgba(255,255,255,0.10)" }}>
        <ResQShield size={28} />
        <div style={{ lineHeight: 1.15 }}>
          <div style={{ fontWeight: 900, fontSize: 18, letterSpacing: "-0.03em", color: WHITE }}>
            RESQ<span style={{ color: "#E01A2E" }}>1</span>
          </div>
          <div style={{ fontSize: 9, letterSpacing: "0.22em", color: W45, fontFamily: MONO, textTransform: "uppercase", marginTop: 3 }}>
            ResQconnect Ops
          </div>
        </div>
      </div>

      <nav style={{ flex: 1, padding: "16px 0" }}>
        {items.map(({ to, label, icon: Icon, testid }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/admin"}
            data-testid={testid}
            style={({ isActive }) => ({
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "10px 20px",
              fontSize: 13,
              textDecoration: "none",
              borderLeft: `2px solid ${isActive ? "#E01A2E" : "transparent"}`,
              background: isActive ? "rgba(255,255,255,0.07)" : "transparent",
              color: isActive ? WHITE : W65,
              transition: "color 0.15s ease, background 0.15s ease",
              letterSpacing: "-0.005em",
              fontWeight: isActive ? 600 : 500,
            })}
          >
            <Icon size={17} weight="duotone" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <div style={{ padding: "16px 20px", borderTop: "1px solid rgba(255,255,255,0.10)" }}>
        <div
          style={{
            fontSize: 10,
            color: W45,
            fontFamily: MONO,
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {user?.email}
        </div>
        <button
          onClick={logout}
          data-testid="logout-button"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            background: "transparent",
            border: 0,
            padding: 0,
            cursor: "pointer",
            color: W65,
            fontSize: 12,
            marginTop: 10,
            fontFamily: "inherit",
          }}
        >
          <SignOut size={13} /> Sign Out
        </button>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginTop: 16,
            fontSize: 9,
            color: W30,
            fontFamily: MONO,
            letterSpacing: "0.14em",
          }}
        >
          <span
            style={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: "#1E9E63",
              boxShadow: "0 0 0 3px rgba(30,158,99,0.25)",
            }}
          />
          DISPATCH LINK · LIVE
        </div>
      </div>
    </aside>
  );
}
